import { render, staticRenderFns } from "./LogoTaskSearchNotFound.vue?vue&type=template&id=0a7e2d48&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports